import { useCallback, useState } from "react";
import { ServiceCalendarPanel } from "./ServiceCalendarPanel";
import { ServiceGateBanner } from "./ServiceGateBanner";
import { ServiceMapPanel } from "./ServiceMapPanel";
import { ghostBtnClass } from "./serviceShared";
import { useServiceAnchorLayerGate } from "./useServiceAnchorLayerGate";

export function ServiceSchedulingPanel() {
  const gate = useServiceAnchorLayerGate();
  const [refreshSignal, setRefreshSignal] = useState(0);
  /** When the calendar picks a day, the route map follows that date (dev-sync d011019d). */
  const [mapRouteDate, setMapRouteDate] = useState<string | undefined>(undefined);

  const handleRefresh = useCallback(() => {
    gate.refresh();
    setRefreshSignal((s) => s + 1);
  }, [gate]);

  return (
    <div className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <div className="min-w-0 space-y-1">
          <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Scheduling</h2>
          <p className="text-xs text-gray-600 dark:text-zinc-400">
            Calendar on the left, route map on the right. Map hints are suggestive — confirm on the
            Board before dispatch.
          </p>
        </div>
        <button
          type="button"
          className={ghostBtnClass}
          onClick={handleRefresh}
          disabled={gate.loading}
        >
          Refresh
        </button>
      </div>

      <ServiceGateBanner gate={gate} />

      {gate.enabled ? (
        <div className="flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:items-start">
          <div className="min-w-0">
            <ServiceCalendarPanel
              embed
              refreshSignal={refreshSignal}
              onSelectedDayChange={setMapRouteDate}
            />
          </div>
          <div className="min-w-0">
            <ServiceMapPanel embed refreshSignal={refreshSignal} syncedRouteDate={mapRouteDate} />
          </div>
        </div>
      ) : null}
    </div>
  );
}
